import { combineReducers, configureStore } from "@reduxjs/toolkit";
import userReducer, { userInitialState } from "./UserSlice";
import notificationReducer, {
  notificationInitialState,
} from "./NotificationsSlice";
import settingsReducer, { settingsInitialState } from "./SettingsSlice";
import permissionsReducer, {
  permissionsInitialState,
} from "./PermissionsSlice";

export const rootReducer = combineReducers({
  user: userReducer,
  globalNotifications: notificationReducer,
  settings: settingsReducer,
  permissions: permissionsReducer,
});

export const store = configureStore({
  reducer: rootReducer,
});

export const initialState = {
  user: userInitialState,
  notification: notificationInitialState,
  settings: settingsInitialState,
  permissions: permissionsInitialState,
};

export type RootState = ReturnType<typeof rootReducer>;
